import * as React from "react";
import { useEffect, useState, useMemo, useCallback } from "react";
import { useDataProvider } from "react-admin";
import useAiInsight from "../../../Components/AiAssistant/useAiInsight";
import { buildAiBaseParams } from "../../../Components/AiAssistant/buildAiBaseParams";
import { Button, Dialog, DialogContent, Typography } from "@material-ui/core";
import GaugeChart from "../../../Components/CustomChart/GaugeChart";
import CockpitRejectionRateViewList from "./CockpitRejectionRateViewList";
import { ViewList } from "@material-ui/icons";

const CockpitRejectionRate = ({ filterParams }) => {
  const dataProvider = useDataProvider();

  const [chartData, setChartData] = useState([] as any);
  const [chartValue, setChartValue] = useState(0);
  const [open, setOpen] = useState(false);

  const resourceEndpoint = "pbhrequestorders/cockpit/rejectionrate";

  const subArcs = [
    {
      limit: 1,
      color: "#5BE12C",
      showTick: true,
    },
    {
      limit: 2,
      color: "#FFC700",
      showTick: true,
    },
    {
      limit: 5,
      color: "#FF7A00",
      showTick: true,
    },
    {
      limit: 10,
      color: "#EA4228",
      showTick: true,
    },
  ];

  const insightParams = useMemo(() => {
    if (!chartData.length) return null;
    const sum = chartData.reduce((s: number, d: any) => s + d.isRejected, 0);
    return {
      ...buildAiBaseParams(filterParams),
      totalRequests: chartData.length.toString(),
      rejectedCount: sum.toString(),
      rejectionRate: chartValue.toFixed(2),
    };
  }, [filterParams, chartValue, chartData]);
  useAiInsight("cockpitrejectionrate", insightParams);

  const GetChartData = useCallback(async () => {
    await dataProvider
      .getList(resourceEndpoint, {
        pagination: { page: 1, perPage: 999999 },
        sort: { field: "id", order: "ASC" },
        filter: filterParams,
      })
      .then(({ data }) => {
        const sum = data.reduce((sum, current) => sum + current.isRejected, 0);
        const avg = Number(((sum / data.length) * 100).toFixed(2));
        setChartData(data);
        setChartValue(avg);
      })
      .catch(error => {
        console.log(error);
      });
  }, [filterParams, dataProvider]);

  useEffect(() => {
    GetChartData();
  }, [GetChartData]);

  return (
    <>
      <Typography gutterBottom variant="h5" component="h2" align="center">
        Rejection Rate
      </Typography>
      <GaugeChart value={chartValue} subArcs={subArcs} maxValue={10} />
      <Button fullWidth startIcon={<ViewList />} onClick={() => setOpen(true)} color="primary">
        View
      </Button>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogContent>
          <CockpitRejectionRateViewList
            filterParams={filterParams}
            resource={resourceEndpoint}
            basePath={resourceEndpoint}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CockpitRejectionRate;
